// replace the numbers in Japanese Zenakaku (０１２３４５６７８９) into ascii numbers
export function translateZenkakuNumbers (num) {
  return num?.replace(/[０-９]/g, s => String.fromCharCode(s.charCodeAt(0) - 0xFEE0))
}
